import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
    ClaimsService,
    DynamicHtmlDirective,
    Logger,
    LoginNavigationService,
    MediaQueryService,
    NativeAppService,
    NavigationService,
    Page,
    PlainLinkComponent,
    SessionStoreService,
    TrackingService,
    UserLoginEvent,
    UserService,
    ViewTemplateForClient,
    WindowRef,
} from '@frontend/vanilla/core';
import { LhHeaderBarComponent } from '@frontend/vanilla/features/header-bar';
import { DarkModeService } from '@frontend/vanilla/shared/dark-mode';
import { cloneDeep } from 'lodash-es';
import { Subject, Subscription } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';

import { CommonClientConfig } from '../client-config/client-config.models';
import { PortalMediaQueryService } from '../common/portal-merdia-query-service';
import { ScriptInjectorService } from '../common/script-injector-service';
import { NewAccountMenuService } from '../services/account-menu-v2.service';
import { PortalNavigationService } from '../services/portal-navigation.service';
import { CommonMethodsService } from '../tracking/common-methods-service';
import { PortalTrackingService } from '../tracking/tracking-resource.service';
import { EventNameConst, TrackingEvent } from './../tracking/tracking.model';
import { ContactResourceService } from './contact-resource.service';
import { ContactInitDataResponse, HelpAndContactData, LinkTemplateItem } from './contact.models';
import { ContactOptionsComponent } from './parts/contact-options.component';
import { EmailOptionComponent } from './parts/email-option.component';

@Component({
    selector: 'pt-focus-contact-page',
    templateUrl: 'focus-contact-page.component.html',
    styleUrls: ['../../styles/portal/components/contact-latest.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        LhHeaderBarComponent,
        NgTemplateOutlet,
        EmailOptionComponent,
        NgClass,
        DynamicHtmlDirective,
        PlainLinkComponent,
        ContactOptionsComponent,
    ],
})
export class FocusContactPageComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() initData: ContactInitDataResponse;
    @Input() faqLink: LinkTemplateItem;
    @Input() twitterLink: LinkTemplateItem;
    @Input() content: ViewTemplateForClient;
    currentSelectedSubCatergoryId: any = null;
    Data: ContactInitDataResponse;
    secondLevelData: any;
    thirdLevelData: any;
    childData: any[] = [];
    hideFirstLevel: boolean = false;
    hideSecondLevel: boolean = true;
    hideThirdLevel: boolean = true;
    hideRemaining: boolean = false;
    showbreadcrumb: boolean = false;
    contactOptionsTileClick: boolean = false;
    popularTopicsLimit: number;
    headerTitle: string;
    promoctalabel: string;
    promoctaurl: string;
    showpromocta: boolean = false;
    levelData: any;
    selectedItem: any;
    level: string = 'first';
    isMobile: boolean;
    isDesktop: boolean;
    watcher: Subscription;
    secondLevelTitle: string;
    thirdLevelTitle: string;
    firstLevelTitle: string;
    showMore: boolean = true;
    hideShowMore: boolean = true;
    currentSelectedCategory: any = null;
    emailScreenContactData: any;
    showEmail: boolean = false;
    optionsScreen: boolean = false;
    showPhone: boolean = false;
    currentSelectedSubCategory: any = null;
    categorySelected: boolean = false;
    currentSelectedCategoryId: any = null;
    helpAndContactData: HelpAndContactData;
    phoneScreenContactData: any;
    subCategoryList: any[] = [];
    selectedSubCategory: boolean = false;
    selectedSubCategoryId: any;
    landingPage: { [key: string]: string };
    subCategory: any = null;
    showpopularArticles: boolean = false;
    currentSelectedCategoryName: string = '';
    hideContactPage: boolean = true;
    attributes: any;
    messages: any;
    copytitle: string = '';
    informationMessage: string | undefined;
    fromBrowseAll: boolean = false;
    popularArticlesData: any = [];
    showSearch: boolean = false;
    contactFromThirdLevel: any;
    additionalContent: any;
    loggedInUser: boolean = false;
    MoreText: string;
    LessText: string;
    contactUsTitle: string;
    fromHcc: boolean = false;
    v2NavEnabled: boolean = false;
    v2NavEnabledPreLogin: boolean = false;
    showContactUsHomepage: boolean = false;
    SelectedArticle: any;
    HccCategory: string = '';
    HccArticle: string = '';
    count25: boolean = false;
    count50: boolean = false;
    count75: boolean = false;
    showchathistory: boolean = false;
    ActionEvent: number;
    @ViewChild('contactimagevideo') contactimagevideo: ElementRef;
    @ViewChild('infoContainer') infoContainer: ElementRef;
    emergencyMessageClosed: boolean = false;
    isCloseIconEnabled: string | undefined;
    showContactUsOnTop: boolean = false;
    enableLoginButtonPhase3: boolean = false;
    categoryId: string = '';
    articleId: string = '';
    categoryName: string = '';
    navigationSource: string = '';
    navigationSourceList: string[] = ['documentupload', 'email', 'mohinterceptor', 'lostPasswordSuccessScreen'];
    highPriority: boolean = false;
    private unsubscribe = new Subject<void>();
    showPlayer: boolean = true;
    thirddata: any;
    isGuideEnabled: boolean = false;
    redirectedFromSASWFlow: boolean = false;
    constructor(
        private navigation: NavigationService,
        private activatedRoute: ActivatedRoute,
        private mediaQueryService: MediaQueryService,
        private renderer: Renderer2,
        private ref: ChangeDetectorRef,
        private user: UserService,
        private loginNavigationService: LoginNavigationService,
        private tracking: TrackingService,
        private windowRef: WindowRef,
        private portalTrackingService: PortalTrackingService,
        private contactResourceService: ContactResourceService,
        public newAccountMenuService: NewAccountMenuService,
        private claimsService: ClaimsService,
        private nativeApplication: NativeAppService,
        public darkModeService: DarkModeService,
        private scriptInjector: ScriptInjectorService,
        private logger: Logger,
        private sessionStorage: SessionStoreService,
        private commonMethodsService: CommonMethodsService,
        private route: ActivatedRoute,
        private portalMediaQueryService: PortalMediaQueryService,
        private portalNavigation: PortalNavigationService,
        public page: Page,
        private commonClientConfig: CommonClientConfig,
    ) {
        this.helpAndContactData = new HelpAndContactData();
    }

    ngOnInit() {
        if (this.commonMethodsService.getGuideConfig().guideEnabled && this.navigation.location.search.get('z-showoptions') == 'true') {
            this.optionsScreen = true;
            this.isGuideEnabled = true;
        }
        this.gotoTop();
        this.v2NavEnabled = this.newAccountMenuService.isNewAccountMenu();
        this.Data = cloneDeep(this.initData);
        this.loggedInUser = this.user.isAuthenticated;
        this.v2NavEnabledPreLogin = !this.v2NavEnabled || (this.v2NavEnabled && !this.loggedInUser);
        this.messages = this.Data.messages;
        this.MoreText = this.messages && this.messages.ShowMore ? this.messages.ShowMore : 'SHOW MORE';
        this.LessText = this.messages && this.messages.ShowLess ? this.messages.ShowLess : 'SHOW LESS';
        this.contactUsTitle = this.messages && this.messages.ContactUs ? this.messages.ContactUs : 'Contact Us';
        this.attributes = this.Data.attributes;
        this.showcontactinhomepage(this.attributes);
        this.headerTitle = this.messages && this.messages.HeaderTitle ? this.messages.HeaderTitle : 'Help & Contact';
        this.firstLevelTitle = this.headerTitle;
        if (this.initData.promoContent) {
            this.promoctalabel = this.initData.promoContent.messages.ctaText;
            this.promoctaurl = this.initData.promoContent.messages.URL;
        }
        this.showSearch = this.Data.showSearchInPhase3;
        this.enableLoginButtonPhase3 = this.Data.enableLoginButtonPhase3;
        if (this.Data.csMessage !== null && this.Data.csMessage !== undefined && this.initData.csMessage.text) {
            this.informationMessage = this.initData.csMessage.text;
            if (this.initData.csMessage.messages && this.initData.csMessage.messages['isCloseIconEnabled'] == 'true')
                this.isCloseIconEnabled = this.initData.csMessage.messages['isCloseIconEnabled'];
        }
        this.navigationSource = this.navigation.location.search.get('source') || '';
        this.redirectedFromSASWFlow = this.navigationSource == 'sasw';
        this.settingFlexLayoutProperties();
        this.bindPopularArticlesData();
        if (this.isMobile) {
            this.popularTopicsLimit = (this.attributes && this.attributes.NoOfPopularTopics) || 5;
        } else {
            this.popularTopicsLimit = 0;
        }
        this.bindcategory(null, this.popularTopicsLimit, 0, false);
        this.landingPage = JSON.parse(this.initData.landingPage);
        if (this.activatedRoute.snapshot.queryParamMap.get('showContact') == 'true' && this.activatedRoute.snapshot.queryParamMap.get('keyword')) {
            this.optionsScreen = true;
        }
        if (this.landingPage[this.initData.playerPriority.toLowerCase()].toLowerCase() === 'contactoptionsscreen') {
            this.optionsScreen = true;
            this.highPriority = true;
        }
        if (this.navigation.location.search.has('source') || this.navigation.location.search.get('type')) {
            if (
                this.navigationSourceList.includes(this.navigationSource) ||
                this.initData.showContactOptionsBySource[this.navigationSource] ||
                (this.navigationSource === 'complaintform' && this.initData.enableGreeceComplaintForm) ||
                this.navigation.location.search.get('type')
            ) {
                this.optionsScreen = true;
            } else if (this.navigationSource === 'registration' && this.optionsScreen !== true) {
                this.initData.newCategoriesList
                    .filter((category: any) => category.id === 'accountaccess')
                    .map((category: any) => {
                        category.checked = true;
                        this.bindcategory(category, 0, 0, true);
                    });
            }
        }
        const sourcecategory = this.activatedRoute.snapshot.params['category'] || this.activatedRoute.snapshot.queryParams['Category'];
        if (sourcecategory) {
            if (this.activatedRoute.snapshot.params['category'] === 'browseall' && this.isMobile) {
                this.BrowseAll();
            } else {
                this.initData.newCategoriesList
                    .filter((category: any) => sourcecategory == category.id)
                    .map((category: any) => {
                        category.checked = true;
                        this.bindcategory(category, 0, 0, true);
                    });
            }
        }
        this.user.events
            .pipe(
                first((e) => e instanceof UserLoginEvent),
                takeUntil(this.unsubscribe),
            )
            .subscribe(() => {
                this.showcontactinhomepage(this.attributes);
                this.contactResourceService.getPostLoginRedirectOverrideContidionUsnj().subscribe((response) => {
                    const isOverrideenWorkflow: boolean = response;
                    if (
                        this.navigation.location.absUrl().indexOf(this.portalNavigation.normalizeUrl('/contact')) > 0 &&
                        isOverrideenWorkflow &&
                        this.user.workflowType == 0
                    )
                        this.windowRef.nativeWindow.location.reload();
                });
            });
        this.adjustShowMoreInInfo(true);
        if (this.initData.enableChatHistory && this.initData.chatHistoryContent && this.initData.chatHistory != null) {
            const chatStatus = JSON.parse(this.initData.chatHistory.toString())[this.initData.playerPriority.toLowerCase()];
            chatStatus && chatStatus.toLowerCase() == 'on' && this.newAccountMenuService.getMenuVersion() != 1
                ? (this.showchathistory = true)
                : (this.showchathistory = false);
        }
        const articlesource = this.navigation.location.search.get('Article');
        const categorysource = this.navigation.location.search.get('Category');
        if (
            this.navigation.location.absUrl().indexOf(this.portalNavigation.normalizeUrl('/contact')) > 1 &&
            this.navigation.location.search.get('source') == 'documentupload' &&
            articlesource &&
            articlesource !== 'not applicable' &&
            categorysource &&
            categorysource !== 'not applicable'
        ) {
            this.showbreadcrumb = true;
            this.hideThirdLevel = false;
            this.optionsScreen = true;
            this.contactUsTitle = this.messages && this.messages.ContactUs ? this.messages.ContactUs : this.messages.ContactUs;
            this.headerTitle = this.contactUsTitle;
            const thirdlevel = this.sessionStorage.get('third-level-data');
            this.thirdLevelData = thirdlevel;
            this.secondLevelTitle =
                this.thirdLevelData && this.thirdLevelData.firstLevelData ? this.thirdLevelData.firstLevelData.category.parent.title : '';
            this.thirdLevelTitle = this.thirdLevelData.title;
            this.Data.newCategoriesList.map((category: any) => {
                if (category.id == categorysource) {
                    this.selectedItem = category;
                    this.fromHcc = false;
                }
            });
            this.popularArticlesData.map((item: any) => {
                if (item.child.metadata.id.itemName == articlesource) {
                    this.SelectedArticle = item;
                    this.fromHcc = true;
                }
            });
            if (this.fromHcc == true) {
                this.contactFromThirdLevel = this.SelectedArticle;
            } else {
                this.contactFromThirdLevel = this.thirdLevelData;
            }
            this.levelData = this.thirdLevelData;
            this.level = 'third';
        } else {
            if (this.navigation.location.search.get('source') == 'documentupload') {
                this.contactUsTitle = this.messages && this.messages.ContactUs ? this.messages.ContactUs : this.messages.ContactUs;
                this.firstLevelTitle = this.contactUsTitle;
                this.headerTitle = this.contactUsTitle;
            }
        }

        if (this.route.snapshot.queryParamMap.has('cat')) this.goToCategory();
    }

    goToCategory() {
        this.categoryName = this.route.snapshot.queryParamMap.get('cat')!;
        if (!this.isNullOrEmpty(this.categoryName.trim())) {
            const category = this.initData.newCategoriesList.find((category: any) => category.id.toLowerCase() === this.categoryName.toLowerCase());
            if (category) {
                category.checked = true; // set the 'checked' property of the matched category to true
                this.bindcategory(category, 0, 0, true);
            }
        }
    }

    isNullOrEmpty(field: string): boolean {
        if (field !== undefined && field !== null && field.length > 0) return false;
        return true;
    }

    goTocontactoption() {
        if (this.initData.enableContactOptionsTile) {
            this.contactOptionsTileClick = true;
            this.optionsScreen = true;
            this.hideFirstLevel = true;
            this.contactUsTitle = this.messages && this.messages.ContactUs ? this.messages.ContactUs : this.messages.ContactUs;
            this.headerTitle = this.contactUsTitle;
        }
        this.tracking.triggerEvent('Event.HCC', {
            'component.CategoryEvent': 'hcc',
            'component.LabelEvent': 'contact us',
            'component.ActionEvent': 'click',
            'component.PositionEvent': 'bottom of the page',
            'component.LocationEvent': 'help & Contact',
            'component.EventDetails': 'contact us cta',
            'component.URLClicked': 'not applicable',
            'component.hccCategory': 'not applicable',
            'component.hccArticle': 'not applicable',
        });
    }
    showcontactinhomepage(attributes: any) {
        let playerpriority: any = this.Data.playerPriority;
        if (this.user.isAuthenticated) {
            playerpriority = this.claimsService.get('playerPriority') ? this.claimsService.get('playerPriority') : this.Data.playerPriority;
        }
        const players = attributes['showContactUs'] ? attributes['showContactUs'].split(',') : [];
        if (players && players.length > 0 && players.indexOf(playerpriority.toLowerCase()) !== -1) {
            this.showContactUsHomepage = true;
        }
        if (attributes['showContactUsOnTop'] && attributes['showContactUsOnTop'] == 'true') {
            this.showContactUsOnTop = true;
        }
    }

    settingFlexLayoutProperties() {
        this.isMobile = this.mediaQueryService.isActive('lt-sm');
        this.isDesktop = this.mediaQueryService.isActive('gt-md');
        if (this.mediaQueryService.isActive('sm') || this.mediaQueryService.isActive('gt-sm')) {
            this.isDesktop = true;
        }
        this.watcher = this.portalMediaQueryService.mediaQuery.subscribe(() => {
            this.isMobile = this.mediaQueryService.isActive('lt-sm');
            if (this.mediaQueryService.isActive('sm') || this.mediaQueryService.isActive('gt-sm')) {
                this.isDesktop = true;
            }
            this.adjustShowMoreInInfo();
        });
    }

    goToDocumentUpload(data: any) {
        let parentTitle = data.firstLevelData ? data.firstLevelData.category.parent.title : '';
        if (data.fromHCC) {
            parentTitle = data.parent.title;
        }
        const trackingEvent: TrackingEvent = {
            CategoryEvent: 'hcc',
            LabelEvent: 'article',
            ActionEvent: 'click',
            PositionEvent: 'bottom of the page',
            LocationEvent: 'categories',
            EventDetails: 'verify now cta',
            UrlClicked: this.windowRef.nativeWindow.location.href,
            HccCategory: this.HccCategory,
            HccArticle: this.HccArticle,
        };
        this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        const uploadDocumentLink =
            this.Data.helpContactContent.messages.VerifyNowPreFooterLink +
            '?source=contactarticle&category=' +
            parentTitle +
            '&article=' +
            data.value.faqTitle;
        if (!this.user.isAuthenticated) {
            this.loginNavigationService.goToLogin({ appendReferrer: uploadDocumentLink });
            return;
        } else {
            return this.navigation.goTo(uploadDocumentLink);
        }
    }

    goToLoginPage(data: any) {
        let parentTitle = data.firstLevelData ? data.firstLevelData.category.parent.data.metadata.id.itemName : '';
        if (data.fromHCC) {
            parentTitle = data.parent.data.metadata.id.itemName;
        }
        const trackingEvent: TrackingEvent = {
            CategoryEvent: 'hcc',
            LabelEvent: 'articles',
            ActionEvent: 'click',
            PositionEvent: 'bottom of the page',
            LocationEvent: 'article',
            EventDetails: 'login cta',
            UrlClicked: this.windowRef.nativeWindow.location.href,
            HccCategory: parentTitle,
            HccArticle: data.value.data.metadata.id.itemName,
        };
        this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        this.loginNavigationService.goToLogin();
        return;
    }

    adjustShowMoreInInfo(loadtrack?: boolean) {
        let pLineHeight: number = 0;
        let noOfRows: number = 0;
        if (this.infoContainer) {
            let element: any = this.infoContainer.nativeElement;
            element = element as HTMLElement;
            if (element && element.getElementsByTagName('p').length > 0) {
                const defaultView: any = document.defaultView;
                for (let i = 0; i < element.getElementsByTagName('p').length; i++) {
                    const pelement: any = element.getElementsByTagName('p')[i];
                    if (pelement) {
                        const defaultView: any = document.defaultView;
                        const offsetHeight: number = Number(pelement.offsetHeight);
                        pLineHeight = parseInt(pelement.style.lineHeight || defaultView.getComputedStyle(pelement, null).lineHeight);
                        noOfRows = noOfRows + Math.ceil(offsetHeight / pLineHeight);
                    }
                }
                this.hideShowMore = noOfRows <= Number(this.attributes['NoOfRowsInfo']);
                const hElement: any =
                    element.getElementsByTagName('h1')[0] ||
                    element.getElementsByTagName('h2')[0] ||
                    element.getElementsByTagName('h3')[0] ||
                    element.getElementsByTagName('h4')[0] ||
                    element.getElementsByTagName('h5')[0] ||
                    element.getElementsByTagName('h6')[0];
                let hLineHeight: number = 0;
                if (hElement) {
                    hLineHeight = parseInt(hElement.style.lineHeight || defaultView.getComputedStyle(hElement, null).lineHeight);
                }
                const elementHeight: number = hLineHeight + (this.hideShowMore ? noOfRows : Number(this.attributes['NoOfRowsInfo'])) * pLineHeight;
                this.renderer.setStyle(element, 'min-height', elementHeight + 'px');
                this.ref.detectChanges();
            }

            if (loadtrack) {
                let level: string;
                if (this.optionsScreen) {
                    level = 'contact US';
                } else {
                    level = this.level ? this.TrackLevel(this.level) : 'homepage';
                }
                const trackingEvent: TrackingEvent = {
                    CategoryEvent: 'hcc',
                    LabelEvent: level,
                    ActionEvent: 'load',
                    PositionEvent: 'top of the page',
                    LocationEvent: 'info message',
                    EventDetails: 'not applicable',
                    UrlClicked: this.windowRef.nativeWindow.location.href,
                    HccCategory: this.level === 'third' && this.HccCategory !== undefined ? this.HccCategory : 'not applicable',
                    HccArticle: this.level === 'third' && this.HccArticle !== undefined ? this.HccArticle : 'not applicable',
                };
                this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
            }
        }
    }

    TrackLevel(level: string) {
        if (level === 'first') {
            return 'homepage';
        }
        if (level === 'second') {
            return 'categories';
        }
        if (level === 'third') {
            return 'articles';
        }
        if (level === 'browse') {
            return 'browse our help topics';
        } else {
            return level;
        }
    }
    TrackLocationLevel(level: string) {
        if (level === 'first') {
            return 'homepage';
        }
        if (level === 'second') {
            return 'categories';
        }
        if (level === 'third') {
            return 'article';
        }
        if (level === 'browse') {
            return 'browse';
        } else {
            return level;
        }
    }

    showmore() {
        if (!this.optionsScreen) {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: this.TrackLevel(this.level),
                ActionEvent: 'click',
                PositionEvent: 'top of the page',
                LocationEvent: 'info message',
                EventDetails: this.showMore ? 'show more' : 'show less',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: this.HccCategory !== '' ? this.HccCategory : 'not applicable',
                HccArticle: this.HccArticle !== '' ? this.HccArticle : 'not applicable',
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        } else if (this.optionsScreen) {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: 'contact us',
                ActionEvent: 'click',
                PositionEvent: 'top of the page',
                LocationEvent: 'info message',
                EventDetails: this.showMore ? 'show more' : 'show less',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: 'not applicable',
                HccArticle: 'not applicable',
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        }
        this.showMore = !this.showMore;
    }

    bindPopularArticlesData() {
        if (this.Data.popularArticleNames && this.Data.popularArticleNames.length > 0) {
            this.Data.newCategoriesList.map((item: any) => {
                item.category.childs.map((child: any) => {
                    if (this.Data.popularArticleNames.indexOf(child.metadata.id.itemName) > -1) {
                        const populardata: { [key: string]: any } = {};
                        populardata['child'] = child;
                        populardata['parent'] = item;
                        this.popularArticlesData.push(populardata);
                    }
                });
            });
            this.showpopularArticles = true;
        }
    }

    bindcategory(item: any, limit?: number, i?: number, fromroute?: boolean, fromcontact?: boolean, articleload?: boolean, level?: string) {
        this.gotoTop();
        this.showbreadcrumb = false;
        if (!this.showPlayer) this.showPlayer = true;
        this.categoryId = item ? item.id : '';
        if (this.initData.promoContent && this.initData.enablePromoCTA)
            this.showpromocta = this.categoryId === this.initData.promoContent.messages.FilterText ? true : false;
        if (item === null && !this.optionsScreen) {
            if (level === undefined || level === null) {
                const trackingEvent: TrackingEvent = {
                    CategoryEvent: 'hcc',
                    LabelEvent: this.TrackLevel(this.level),
                    ActionEvent: 'load',
                    PositionEvent: 'not applicable',
                    LocationEvent: this.level === 'browse' ? 'browse' : 'homepage',
                    EventDetails: this.level === 'browse' ? this.TrackLevel(this.level) : 'homepage',
                    UrlClicked: this.windowRef.nativeWindow.location.href,
                    HccCategory: 'not applicable',
                    HccArticle: 'not applicable',
                };
                this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
            }
            if (level !== undefined && level !== null) {
                const trackingEvent: TrackingEvent = {
                    CategoryEvent: 'hcc',
                    LabelEvent: level !== undefined ? this.TrackLevel(level) : 'not applicable',
                    ActionEvent: 'load',
                    PositionEvent: 'not applicable',
                    LocationEvent: this.TrackLocationLevel(this.level),
                    EventDetails: this.TrackLevel(this.level),
                    UrlClicked: this.windowRef.nativeWindow.location.href,
                    HccCategory: 'not applicable',
                    HccArticle: 'not applicable',
                };
                this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
            }
            if (limit) {
                this.Data.newCategoriesList = this.Data.newCategoriesList.slice(0, limit);
            } else {
                this.Data = cloneDeep(this.initData);
                this.levelData = this.Data;
                // this.headerTitle = item.category.parent.title;
            }
            if (this.isMobile) {
                this.capturePageLoadTracking('mobilehomepage');
            }
            if (this.isDesktop) {
                this.capturePageLoadTracking('desktophomepage');
            }
            this.hideFirstLevel = false;
            this.hideSecondLevel = true;
            this.hideThirdLevel = true;
            this.secondLevelTitle = '';
            this.thirdLevelTitle = '';
        }
        if (item) {
            if (fromcontact) {
                this.optionsScreen = false;
                this.level = 'second';
                const trackingEvent: TrackingEvent = {
                    CategoryEvent: 'hcc',
                    LabelEvent: 'contact us',
                    ActionEvent: 'click',
                    PositionEvent: 'Help & Contact' + '/' + item.id,
                    LocationEvent: 'categories',
                    EventDetails: 'breadcrumb navigation',
                    UrlClicked: this.windowRef.nativeWindow.location.href,
                    HccCategory: this.HccCategory,
                    HccArticle: this.HccArticle,
                };
                this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
            }
            if (!articleload) {
                const trackingEvent: TrackingEvent = {
                    CategoryEvent: 'hcc',
                    LabelEvent: 'categories',
                    ActionEvent: 'load',
                    PositionEvent: 'not applicable',
                    LocationEvent: this.TrackLocationLevel(this.level),
                    EventDetails: 'categories',
                    UrlClicked: this.windowRef.nativeWindow.location.href,
                    HccCategory: 'not applicable',
                    HccArticle: 'not applicable',
                };
                this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
            }

            if (this.level === 'browse') {
                this.capturePageLoadTracking('browse our help topics' + item.id);
            }

            if (i !== 0) {
                const trackingEvent: TrackingEvent = {
                    CategoryEvent: 'hcc',
                    LabelEvent: this.TrackLevel(this.level),
                    ActionEvent: 'click',
                    PositionEvent: i ? i.toString() : '1',
                    LocationEvent: this.level === 'browse' ? 'browse' : 'homepage',
                    EventDetails: 'top category',
                    UrlClicked: this.windowRef.nativeWindow.location.href,
                    HccCategory: item.id,
                    HccArticle: 'not applicable',
                };
                this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
            }
            this.childData = [];
            item.category.childs.map((child: any) => {
                const newSubCategoriesList: { [key: string]: any } = {};
                newSubCategoriesList['value'] = child;
                newSubCategoriesList['title'] = child.faqTitle;
                newSubCategoriesList['firstLevelData'] = item;
                this.childData.push(newSubCategoriesList);
            });
            this.headerTitle = item.category.parent.title;
            this.secondLevelTitle = item.category.parent.title;
            this.secondLevelData = this.childData;
            this.hideFirstLevel = true;
            this.hideSecondLevel = false;
            this.hideThirdLevel = true;
            this.level = 'second';
            this.levelData = this.secondLevelData;
            if (this.activatedRoute.snapshot.params['subcategory'] && fromroute) {
                this.secondLevelData
                    .filter((level: any) => this.activatedRoute.snapshot.params['subcategory'] == level.value.metadata.id.itemName)
                    .map((level: any) => {
                        const articledata: { [key: string]: any } = {};
                        articledata['firstLevelData'] = item;
                        articledata['value'] = level.value;
                        articledata['title'] = level.value.faqTitle;
                        this.bindsubcategory(articledata);
                    });
            }
            this.selectedCategoryList(item);
        }
        if (!articleload) {
            setTimeout(() => {
                this.adjustShowMoreInInfo(true);
            }, 100);
        }
    }

    BrowseAll(lvl?: string) {
        if (lvl === undefined || lvl === null) {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: 'homepage',
                ActionEvent: 'click',
                PositionEvent: '1',
                LocationEvent: 'browse',
                EventDetails: 'browse our help topics',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: 'not applicable',
                HccArticle: 'not applicable',
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        }
        // this.capturePageLoadTracking('browse all topics');
        this.gotoTop();
        this.hideRemaining = true;
        this.showpopularArticles = false;
        this.headerTitle = this.messages.BrowseAllHelpTopics;
        this.level = 'browse';
        this.fromBrowseAll = true;
        this.bindcategory(null, 0, 0, false, false, false);
    }

    bindsubcategory(item: any, fromHCC?: boolean, i?: number) {
        this.showpromocta = false;
        this.showbreadcrumb = false;
        this.HccCategory = fromHCC ? item.parent.id : item.firstLevelData.id;
        this.HccArticle = fromHCC ? item.child.metadata.id.itemName : item.value.metadata.id.itemName;
        this.articleId = item && item.value ? item.value.metadata.id.itemName : '';
        if (!this.hideThirdLevel && !this.optionsScreen && this.isDesktop) {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: 'article',
                ActionEvent: 'click',
                PositionEvent: this.HccCategory + '/' + this.HccArticle,
                LocationEvent: 'article',
                EventDetails: 'left navigation',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: this.HccCategory,
                HccArticle: this.HccArticle,
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        }
        this.SelectedArticle = item;
        const highlighted = document.getElementsByClassName('user-menu-item-active');
        if (highlighted.length > 0) {
            highlighted[0].classList.remove('class', 'user-menu-item-active');
        }
        this.gotoTop();
        if (item) {
            const loadtrackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: 'articles',
                ActionEvent: 'load',
                PositionEvent: 'not applicable',
                LocationEvent: 'articles',
                EventDetails: 'articles',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: this.HccCategory,
                HccArticle: this.HccArticle,
            };
            this.portalTrackingService.trackEvents(loadtrackingEvent, '', EventNameConst.HelpAndContact);
            if (fromHCC && item.child) {
                this.fromHcc = true;
                this.capturePageLoadTracking('browse our help topics' + '/' + item.child.metadata.id.itemName);
                if (!this.optionsScreen) {
                    const trackingEvent: TrackingEvent = {
                        CategoryEvent: 'hcc',
                        LabelEvent: 'homepage',
                        ActionEvent: 'click',
                        PositionEvent: i ? i.toString() : '1',
                        LocationEvent: 'article',
                        EventDetails: 'top article',
                        UrlClicked: this.windowRef.nativeWindow.location.href,
                        HccCategory: item.parent.id,
                        HccArticle: item.child.metadata.id.itemName,
                    };
                    this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
                }
                if (this.optionsScreen && this.isDesktop) {
                    const trackingEvent2: TrackingEvent = {
                        CategoryEvent: 'hcc',
                        LabelEvent: 'contact us',
                        ActionEvent: 'click',
                        PositionEvent: 'Help & Contact' + '/' + item.child.metadata.id.itemName,
                        LocationEvent: 'article',
                        EventDetails: 'breadcrumb navigation',
                        UrlClicked: this.windowRef.nativeWindow.location.href,
                        HccCategory: item.parent.id,
                        HccArticle: item.child.metadata.id.itemName,
                    };
                    this.portalTrackingService.trackEvents(trackingEvent2, '', EventNameConst.HelpAndContact);
                }
                this.secondLevelData = [];
                this.thirdLevelData = {};
                this.thirdLevelData['value'] = item.child;
                this.thirdLevelData['fromHCC'] = fromHCC;
                this.thirdLevelData['title'] = item.child.faqTitle;
                this.thirdLevelData['parent'] = item.parent.category.parent;
                this.thirdLevelTitle = item.child.faqTitle;
                setTimeout(() => {
                    this.focus(item.child.faqTitle);
                }, 100);
                this.bindcategory(item.parent, 0, 0, false, false, true);
                this.levelData = this.thirdLevelData;
                this.headerTitle = item.child.faqTitle;
                this.secondLevelTitle = '';
            } else {
                if (this.hideThirdLevel && !this.optionsScreen) {
                    const trackingEvent: TrackingEvent = {
                        CategoryEvent: 'hcc',
                        LabelEvent: 'categories',
                        ActionEvent: 'click',
                        PositionEvent: i ? i.toString() : '1',
                        LocationEvent: 'categories',
                        EventDetails: 'top article',
                        UrlClicked: this.windowRef.nativeWindow.location.href,
                        HccCategory: item.firstLevelData.id,
                        HccArticle: item.value.metadata.id.itemName,
                    };
                    this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
                }
                if (this.optionsScreen && this.fromHcc === false && this.isDesktop) {
                    const trackingEvent2: TrackingEvent = {
                        CategoryEvent: 'hcc',
                        LabelEvent: 'contact us',
                        ActionEvent: 'click',
                        PositionEvent: 'Help & Contact' + '/' + item.firstLevelData.id + '/' + item.value.metadata.id.itemName,
                        LocationEvent: 'categories',
                        EventDetails: 'breadcrumb navigation',
                        UrlClicked: this.windowRef.nativeWindow.location.href,
                        HccCategory: item.firstLevelData.id,
                        HccArticle: item.value.metadata.id.itemName,
                    };
                    this.portalTrackingService.trackEvents(trackingEvent2, '', EventNameConst.HelpAndContact);
                }
                this.thirdLevelData = item;
                this.levelData = item;
                this.headerTitle = item.title;
                this.thirdLevelTitle = item.title;
                setTimeout(() => {
                    this.focus(item.title);
                }, 100);
                this.capturePageLoadTracking('home page' + this.HccArticle);
            }
            if (this.isMobile) {
                this.hideSecondLevel = true;
            } else {
                this.hideSecondLevel = false;
            }
            this.hideFirstLevel = true;
            this.hideThirdLevel = false;
            this.level = 'third';
            this.copytitle = this.thirdLevelData.value.copyTitle;
            this.optionsScreen = false;
            this.adjustShowMoreInInfo(true);
            setTimeout(() => {
                this.videotrack();
            }, 100);
        }
        this.thirddata = this.thirdLevelData;
        this.sessionStorage.set('third-level-data', this.thirddata);

        if (this.helpAndContactData.showButtons) this.helpAndContactData.showButtons = false;
    }

    private loadCloudfarePlayerScript() {
        this.scriptInjector.inject('player').then(
            () => {
                this.setupEventListeners();
                this.handleVideoTracking('load');
            },
            (error) => {
                this.logger.error('Failed to load external script to populate with key player', error);
            },
        );
    }

    private setupEventListeners() {
        const stream = this.windowRef.nativeWindow['Stream'];
        const element = document.getElementsByClassName('embed-responsive-item')[0];
        const player = stream(element);

        if (element.getAttribute('listenerAdded') !== 'true') {
            player.addEventListener('play', () => this.handleVideoTracking('start'));
            player.addEventListener('timeupdate', () => {
                if (player.currentTime == player.duration) this.handleVideoTracking('end');
                else this.videoMileStoneTracking(player.currentTime, player.duration);
            });
            player.addEventListener('pause', () => this.handleVideoTracking('pause'));
            element.setAttribute('listenerAdded', 'true');
        }
    }

    private handleVideoTracking(action: string) {
        let trackingEvent: TrackingEvent = {
            CategoryEvent: 'hcc',
            LabelEvent: 'article',
            ActionEvent: action,
            PositionEvent: 'not applicable',
            LocationEvent: 'article',
            EventDetails: 'video',
            UrlClicked: 'not applicable',
            HccCategory: this.HccCategory,
            HccArticle: this.HccArticle,
        };

        if (action == 'pause' && this.ActionEvent !== 100) trackingEvent = { ...trackingEvent, LabelEvent: 'hcc videos' };
        if (action == 'end') this.count25 = this.count50 = this.count75 = false;

        this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
    }

    videotrack() {
        if (this.contactimagevideo) {
            const element: HTMLElement = this.contactimagevideo.nativeElement as HTMLElement;
            /* Check if iframe exists */
            if (element.getElementsByClassName('embed-responsive-item') && element.getElementsByClassName('embed-responsive-item').length > 0)
                this.loadCloudfarePlayerScript();
        }
    }

    videoMileStoneTracking(currentTime: number, duration: number) {
        this.ActionEvent = Math.ceil((currentTime * 100) / duration);
        if (this.ActionEvent < 25) {
            this.count25 = false;
            this.count50 = false;
            this.count75 = false;
        }
        if (this.ActionEvent > 25 && this.ActionEvent < 50 && !this.count25) {
            this.ActionEvent = 25;
            this.milestonetrack(this.ActionEvent);
            this.count25 = true;
        } else if (this.ActionEvent > 50 && this.ActionEvent < 75 && !this.count50) {
            this.ActionEvent = 50;
            this.milestonetrack(this.ActionEvent);
            this.count50 = true;
        } else if (this.ActionEvent > 75 && this.ActionEvent < 100 && !this.count75) {
            this.ActionEvent = 75;
            this.milestonetrack(this.ActionEvent);
            this.count75 = true;
        } else if (this.ActionEvent == 100) {
            this.ActionEvent = 100;
            this.milestonetrack(this.ActionEvent);
        }
    }

    milestonetrack(ActionEvent: number) {
        const mileStoneTrackingEvent: TrackingEvent = {
            CategoryEvent: 'hcc',
            LabelEvent: 'article',
            ActionEvent: `${ActionEvent}% milestone complete`,
            PositionEvent: 'not applicable',
            LocationEvent: 'article',
            EventDetails: 'video',
            UrlClicked: 'not applicable',
            HccCategory: this.HccCategory,
            HccArticle: this.HccArticle,
        };
        this.portalTrackingService.trackEvents(mileStoneTrackingEvent, '', EventNameConst.HelpAndContact);
    }

    focus(id: string) {
        const div = document.getElementById(id);
        if (div) {
            div.setAttribute('class', 'user-menu-item-active');
        }
    }

    close(headerclose?: boolean, headerback?: boolean) {
        this.closeVideo();
        if (this.isMobile && !headerclose && !headerback) {
            this.headerTitle = this.firstLevelTitle;
        }
        if (headerclose) {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: this.optionsScreen ? 'contact us' : this.TrackLevel(this.level),
                ActionEvent: 'click',
                PositionEvent: 'top right of the page',
                LocationEvent: this.optionsScreen ? 'contact us' : this.TrackLocationLevel(this.level),
                EventDetails: 'close (x)',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: this.level === 'third' && this.HccCategory !== '' ? this.HccCategory : 'not applicable',
                HccArticle: this.level === 'third' && this.HccArticle !== '' ? this.HccArticle : 'not applicable',
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        } else if (headerback) {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: this.TrackLevel(this.level),
                ActionEvent: 'click',
                PositionEvent: 'top left of the page',
                LocationEvent: this.TrackLocationLevel(this.level),
                EventDetails: 'back',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: 'not applicable',
                HccArticle: 'not applicable',
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        } else {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: 'articles',
                ActionEvent: 'click',
                PositionEvent: 'bottom of the page',
                LocationEvent: 'article',
                EventDetails: 'No',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: this.HccCategory !== undefined ? this.HccCategory : 'not applicable',
                HccArticle: this.HccArticle !== undefined ? this.HccArticle : 'not applicable',
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        }
        if ((!this.showbreadcrumb && !headerclose && !headerback) || (this.contactOptionsTileClick && headerback && this.optionsScreen)) {
            this.hideFirstLevel = false;
            this.hideSecondLevel = true;
            this.hideThirdLevel = true;
            this.newAccountMenuService.scrollToTop();
        } else {
            if (headerback && !this.contactOptionsTileClick && this.optionsScreen)
                this.navigation.goToLastKnownProduct({ forceHistoryBack: this.windowRef.nativeWindow.history.length > 2 ? true : false });
            else return this.navigation.goToLastKnownProduct({ forceHistoryBack: false });
        }
        if (
            this.navigation.location.search.has('source') &&
            ((this.showbreadcrumb && this.navigation.location.search.get('source') === 'documentupload') ||
                this.navigation.location.search.get('source') === 'interceptor' ||
                (!this.contactOptionsTileClick && this.navigation.location.search.get('source') === 'jumiokyc'))
        ) {
            this.navigation.goToLastKnownProduct({ forceHistoryBack: false });
        } else if (this.navigation.location.search.get('source') === 'mohinterceptor') {
            if (this.nativeApplication.isNativeApp) {
                this.loginNavigationService.goToHome();
            } else this.navigation.goToLastKnownProduct();
        } else if ((!headerclose && !headerback) || (this.contactOptionsTileClick && headerback && this.optionsScreen)) {
            this.hideFirstLevel = false;
            this.hideSecondLevel = true;
            this.hideThirdLevel = true;
            this.newAccountMenuService.scrollToTop();
        } else {
            this.navigation.goToLastKnownProduct({ forceHistoryBack: this.windowRef.nativeWindow.history.length > 2 ? true : false });
        }
    }

    gotoTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    goBack(Data: any, lvl: string, fromHeader?: boolean, left?: boolean) {
        if (this.activatedRoute.snapshot.queryParamMap.get('backToPrevious') === 'true') {
            this.windowRef.nativeWindow.history.back();
            return;
        }
        if (this.commonMethodsService.getGuideConfig().guideEnabled && this.navigation.location.search.get('z-showoptions') == 'true') {
            this.portalNavigation.navigate('/guide');
            return;
        }

        this.closeVideo();
        this.gotoTop();
        this.hideRemaining = false;
        if (!this.highPriority) this.showpopularArticles = true;
        if (lvl === 'second') {
            if (this.fromBrowseAll) {
                this.BrowseAll(lvl);
                const trackingEvent: TrackingEvent = {
                    CategoryEvent: 'hcc',
                    LabelEvent: 'categories',
                    ActionEvent: 'click',
                    PositionEvent: 'top teft of the page',
                    LocationEvent: this.TrackLocationLevel(lvl),
                    EventDetails: fromHeader ? 'back' : 'breadcrumb navigation',
                    UrlClicked: this.windowRef.nativeWindow.location.href,
                    HccCategory: 'not applicable',
                    HccArticle: 'not applicable',
                };
                this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
            } else {
                this.level = 'first';
                this.bindcategory(null, this.popularTopicsLimit, 0, false, false, false);
                this.headerTitle = this.messages.HeaderTitle;
                const trackingEvent: TrackingEvent = {
                    CategoryEvent: 'hcc',
                    LabelEvent: 'categories',
                    ActionEvent: 'click',
                    PositionEvent: 'top teft of the page',
                    LocationEvent: this.TrackLocationLevel(this.level),
                    EventDetails: fromHeader ? 'back' : 'breadcrumb navigation',
                    UrlClicked: this.windowRef.nativeWindow.location.href,
                    HccCategory: 'not applicable',
                    HccArticle: 'not applicable',
                };
                this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
            }
        }
        if (lvl === 'browse') {
            this.level = 'first';
            this.bindcategory(null, this.popularTopicsLimit, 0, false, false, false);
            this.headerTitle = this.messages.HeaderTitle;
            this.fromBrowseAll = false;
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: 'browse our help topics',
                ActionEvent: 'click',
                PositionEvent: 'top left of the page',
                LocationEvent: this.TrackLocationLevel(this.level),
                EventDetails: fromHeader ? 'back' : 'breadcrumb navigation',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: 'not applicable',
                HccArticle: 'not applicable',
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        } else if (lvl === 'third') {
            if (Data.fromHCC || this.fromHcc) {
                this.level = 'first';
                if (!this.optionsScreen) {
                    this.bindcategory(null, this.popularTopicsLimit, 0, false, false, false);
                }
                if (this.fromHcc && this.headerTitle !== this.contactUsTitle) {
                    this.fromHcc = false;
                }
                this.headerTitle = this.messages.HeaderTitle;
                if (this.optionsScreen) {
                    const trackingEvent: TrackingEvent = {
                        CategoryEvent: 'hcc',
                        LabelEvent: 'contact us',
                        ActionEvent: 'click',
                        PositionEvent: 'top of the page',
                        LocationEvent: this.TrackLocationLevel(lvl),
                        EventDetails: fromHeader || left ? 'back' : 'breadcrumb navigation',
                        UrlClicked: this.windowRef.nativeWindow.location.href,
                        HccCategory: 'not applicable',
                        HccArticle: 'not applicable',
                    };
                    this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
                }
                if (!this.optionsScreen) {
                    const trackingEvent: TrackingEvent = {
                        CategoryEvent: 'hcc',
                        LabelEvent: this.TrackLevel(lvl),
                        ActionEvent: 'click',
                        PositionEvent: 'top of the page',
                        LocationEvent: this.TrackLocationLevel(lvl),
                        EventDetails: fromHeader || left ? 'back' : 'breadcrumb navigation',
                        UrlClicked: this.windowRef.nativeWindow.location.href,
                        HccCategory: this.HccCategory !== undefined ? this.HccCategory : 'not applicable',
                        HccArticle: this.HccArticle !== undefined ? this.HccArticle : 'not applicable',
                    };
                    this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
                }
            } else {
                if (this.optionsScreen && !this.isDesktop) {
                    const trackingEvent: TrackingEvent = {
                        CategoryEvent: 'hcc',
                        LabelEvent: 'contact us',
                        ActionEvent: 'click',
                        PositionEvent: this.HccCategory + '/' + this.HccArticle,
                        LocationEvent: 'articles',
                        EventDetails: fromHeader || left ? 'back' : 'breadcrumb navigation',
                        UrlClicked: this.windowRef.nativeWindow.location.href,
                        HccCategory: this.HccCategory ? this.HccCategory : 'not applicable',
                        HccArticle: this.HccArticle ? this.HccArticle : 'not applicable',
                    };
                    this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
                }
                if (!this.optionsScreen) {
                    const trackingEvent: TrackingEvent = {
                        CategoryEvent: 'hcc',
                        LabelEvent: this.TrackLevel(this.level),
                        ActionEvent: 'click',
                        PositionEvent: fromHeader ? 'not applicable' : 'Help & Contact' + '/' + this.HccCategory,
                        LocationEvent: this.TrackLocationLevel(this.level),
                        EventDetails: fromHeader ? 'back' : 'breadcrumb navigation',
                        UrlClicked: this.windowRef.nativeWindow.location.href,
                        HccCategory: this.HccCategory ? this.HccCategory : 'not applicable',
                        HccArticle: this.HccArticle ? this.HccArticle : 'not applicable',
                    };
                    this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
                }
                this.level = 'second';
                if (!this.optionsScreen) {
                    this.bindcategory(Data.firstLevelData, 0, 0, false, false, false);
                }
                this.levelData = Data.firstLevelData;
                this.headerTitle = Data.firstLevelData.category.parent.title;
            }
        } else if (lvl === 'first') {
            this.close(false, true);
            if (this.isDesktop) {
                const trackingEvent: TrackingEvent = {
                    CategoryEvent: 'hcc',
                    LabelEvent: 'homepage',
                    ActionEvent: 'click',
                    PositionEvent: 'top of the page',
                    LocationEvent: 'home page',
                    EventDetails: fromHeader ? 'back' : 'breadcrumb navigation',
                    UrlClicked: this.windowRef.nativeWindow.location.href,
                    HccCategory: 'not applicable',
                    HccArticle: 'not applicable',
                };
                this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
            }
        }

        if (this.optionsScreen) {
            if (this.contactFromThirdLevel) {
                Data.fromHCC ? this.bindsubcategory(this.contactFromThirdLevel, true, 0) : this.bindsubcategory(this.contactFromThirdLevel);
                this.contactFromThirdLevel = null;
            } else {
                if (!this.highPriority) {
                    this.optionsScreen = false;
                    this.hideFirstLevel = false;
                    this.level = 'first';
                    this.hideContactPage = true;
                    this.headerTitle = this.messages.HeaderTitle;
                }
            }
        }
        if (
            this.landingPage[this.initData.playerPriority.toLowerCase()].toLowerCase() !== 'contactoptionsscreen' &&
            this.navigation.location.search.get('source') != 'mohinterceptor'
        ) {
            if (this.helpAndContactData.showButtons) {
                this.optionsScreen = false;
                this.helpAndContactData.showButtons = false;
                if (this.currentSelectedCategoryId !== null) {
                    this.initData.newCategoriesList.map((category: any) => {
                        if (category.id === this.currentSelectedCategoryId) {
                            category.checked = true;
                        } else {
                            category.checked = false;
                        }
                    });
                    this.subCategoryList.map((subcategory: any) => {
                        if (subcategory.value.metadata.id.itemName === this.currentSelectedSubCatergoryId) {
                            subcategory.checked = true;
                        } else {
                            subcategory.checked = false;
                        }
                    });
                }
                return;
            }
        }
    }

    selectedCategoryList(selectedItem: any) {
        this.categorySelected = true;
        if (selectedItem.id !== this.currentSelectedCategoryId) {
            this.selectedItem = selectedItem;
            this.subCategoryList = [];
            this.selectedSubCategory = false;
            this.subCategory = selectedItem.category;
            this.currentSelectedCategory = selectedItem.category;
            this.currentSelectedCategoryId = selectedItem.id;
            if (selectedItem.category.parent != undefined) this.currentSelectedCategoryName = selectedItem.category.parent.title;

            this.subCategory.childs.map((child: any) => {
                const objectCategory: { [key: string]: any } = {};
                objectCategory['value'] = child;
                objectCategory['title'] = child.faqTitle;
                this.subCategoryList.push(objectCategory);
            });
        }
        if (this.activatedRoute.snapshot.params['subcategory']) {
            this.subCategoryList
                .filter((subCategory: any) => this.activatedRoute.snapshot.params['subcategory'] == subCategory.value.metadata.id.itemName)
                .map((subCategory: any, index: any) => {
                    subCategory.checked = true;
                    if (this.initData.helpAndContactUxCleanUpEnabled) {
                        this.selectedSubCategoryId = '#contactSubRadio' + index;
                    }
                    this.selectedSubCategoryList(subCategory);
                });
        }
        this.capturePageLoadTracking('Help_Contact_HP_nonVIP_Section2');
    }

    selectedSubCategoryList(selectedSubCategory: any) {
        this.currentSelectedSubCatergoryId = selectedSubCategory.value.metadata.id.itemName;
        this.currentSelectedSubCategory = selectedSubCategory;
        this.selectedSubCategory = true;
        this.capturePageLoadTracking('Help_Contact_HP_nonVIP_Section3');
    }

    isNullOrUndefined(str: string): boolean {
        if (str !== undefined && str !== null && str.length > 0) {
            return false;
        }
        return true;
    }

    goToOptions(fromarticle: boolean) {
        this.optionsScreen = true;
        if (fromarticle) {
            this.contactFromThirdLevel = this.SelectedArticle;
            this.currentSelectedSubCategory = this.SelectedArticle;
        }
        this.headerTitle = this.messages && this.messages.ContactUs ? this.messages.ContactUs : 'Contact Us';
        const trackingEvent: TrackingEvent = {
            CategoryEvent: 'hcc',
            LabelEvent: 'articles',
            ActionEvent: 'click',
            PositionEvent: 'bottom of the page',
            LocationEvent: 'article',
            EventDetails: 'Yes',
            UrlClicked: this.windowRef.nativeWindow.location.href,
            HccCategory: this.HccCategory !== '' ? this.HccCategory : 'not applicable',
            HccArticle: this.HccArticle !== '' ? this.HccArticle : 'not applicable',
        };
        this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        this.adjustShowMoreInInfo(true);
    }

    faqLinkClick(el: any) {
        if (el.target.nodeName.toLowerCase() === 'a') {
            this.captureEventTracking('Help_Contact_HP_nonVIP_Section3_Link_Clicked');
        }
    }
    async onback() {
        if (this.isGuideEnabled) {
            this.portalNavigation.navigate('/guide');
        } else {
            if (!this.loggedInUser) {
                await this.navigation.goToLastKnownProductAsync();
                return;
            } else if (this.navigation.location.search.get('source') == 'contact') {
                this.loginNavigationService.goToHome();
            }
            const eName = this.initData.enablePokerNavigateBack ? 'NavigateBack' : 'showLobby';
            if (window.history.length > 1) {
                if (this.nativeApplication.isDownloadClient && this.initData.enablePokerNavigateBack) {
                    this.nativeApplication.sendToNative({ eventName: eName, parameters: {} });
                }
                window.history.go(-1);
            } else {
                if (this.nativeApplication.isDownloadClient || this.newAccountMenuService.isCustomerHubEnabled()) {
                    if (this.nativeApplication.applicationName == 'pokermc') {
                        this.nativeApplication.sendToNative({ eventName: eName, parameters: {} });
                    } else {
                        this.nativeApplication.sendToNative({ eventName: 'showLobby', parameters: {} });
                    }
                } else this.loginNavigationService.goToHome();
            }
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: 'homepage',
                ActionEvent: 'click',
                PositionEvent: 'top left of the page',
                LocationEvent: 'homepage',
                EventDetails: 'back',
                UrlClicked: 'not applicable',
                HccArticle: 'not applicable',
                HccCategory: 'not applicable',
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', 'Event.HCC');
        }
    }
    clickedFirstLevel(fromarticle?: boolean) {
        this.closeVideo();
        if (!this.optionsScreen) {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: fromarticle || this.fromHcc ? 'article' : 'category',
                ActionEvent: 'click',
                PositionEvent: 'Help & Contact',
                LocationEvent: 'home page',
                EventDetails: 'breadcrumb navigation',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: this.fromHcc ? this.HccCategory : this.currentSelectedCategoryName,
                HccArticle: fromarticle ? this.HccArticle : 'not applicable',
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        }
        if (this.optionsScreen) {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: 'contact us',
                ActionEvent: 'click',
                PositionEvent: 'Help & Contact',
                LocationEvent: 'home page',
                EventDetails: 'breadcrumb navigation',
                UrlClicked: this.windowRef.nativeWindow.location.href,
                HccCategory: this.HccCategory,
                HccArticle: this.HccArticle,
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        }

        this.gotoTop();
        this.fromHcc = false;
        this.optionsScreen = false;
        this.level = 'first';
        this.bindcategory(null);
        this.hideContactPage = true;
    }

    emailScreenLoad(data: any) {
        this.emailScreenContactData = data;
    }

    enableEmailScreen(showEmail: boolean) {
        this.showEmail = showEmail;
    }

    disableEmailScreen(goToContactOptionScreen: boolean) {
        this.showEmail = false;
        this.optionsScreen = goToContactOptionScreen;
        this.helpAndContactData.showEmailScreen = false;
        this.helpAndContactData.showButtons = true;
        setTimeout(() => {
            this.adjustShowMoreInInfo();
        }, 100);
    }

    enablePhoneScreen(data: any) {
        this.phoneScreenContactData = data;
        this.showPhone = data.showPhone;
    }

    disablePhoneScreen(showPhone: boolean) {
        this.showPhone = showPhone;
        this.optionsScreen = true;
        this.helpAndContactData.showButtons = false;
    }

    promoctaEvent() {
        this.tracking
            .triggerEvent('Event.HCC', {
                'component.CategoryEvent': 'hcc',
                'component.LabelEvent': 'categories',
                'component.ActionEvent': 'click',
                'component.PositionEvent': 'top of the page',
                'component.LocationEvent': 'categories',
                'component.EventDetails': this.promoctalabel,
                'component.URLClicked': this.promoctaurl,
                'component.hccCategory': 'us-promotionandbonuses',
                'component.hccArticle': 'not applicable',
            })
            .then(() => this.navigation.goTo(this.promoctaurl));
    }

    contactUsClick() {
        const trackingEvent: TrackingEvent = {
            CategoryEvent: 'hcc',
            LabelEvent: 'homepage',
            ActionEvent: 'click',
            PositionEvent: '2',
            LocationEvent: 'home page',
            EventDetails: 'contact us',
            UrlClicked: this.windowRef.nativeWindow.location.href,
            HccCategory: 'not applicable',
            HccArticle: 'not applicable',
        };
        this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        this.level = 'contact_us';
        this.optionsScreen = true;
        this.hideFirstLevel = true;
        this.hideSecondLevel = true;
        this.hideThirdLevel = true;
        this.hideContactPage = false;
        this.secondLevelTitle = 'Contact Us';
        this.headerTitle = 'Contact Us';
        this.adjustShowMoreInInfo(true);
    }
    closeEmergencyMsg() {
        this.emergencyMessageClosed = !this.emergencyMessageClosed;

        const trackingEvent: TrackingEvent = {
            CategoryEvent: 'hcc',
            LabelEvent: this.TrackLevel(this.level),
            ActionEvent: 'click',
            PositionEvent: 'top of the page',
            LocationEvent: 'info message',
            EventDetails: 'close',
            UrlClicked: this.windowRef.nativeWindow.location.href,
            HccCategory: (this.level === 'second' || this.level === 'third') && this.categoryId != '' ? this.categoryId : 'not applicable',
            HccArticle: this.level === 'third' && this.HccArticle != '' ? this.HccArticle : 'not applicable',
        };
        this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
    }
    goToHistory() {
        this.tracking.triggerEvent('Event.HCC', {
            'component.CategoryEvent': 'hcc',
            'component.LabelEvent': 'chat history',
            'component.ActionEvent': 'click',
            'component.PositionEvent': 'suggestions',
            'component.LocationEvent': 'homepage',
            'component.EventDetails': 'chat history option',
            'component.URLClicked': 'not applicable',
            'component.hccCategory': 'not applicable',
            'component.hccArticle': 'not applicable',
        });
        this.portalNavigation.navigate('/chathistory');
    }

    ngAfterViewInit() {
        this.gotoTop();
        this.adjustShowMoreInInfo();
    }

    ngOnDestroy() {
        if (this.watcher) {
            this.watcher.unsubscribe();
        }
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    private captureEventTracking(eventName: string) {
        this.tracking.triggerEvent('Event.Functionality.HelpContact', { 'page.referringAction': eventName });
    }
    private capturePageLoadTracking(eventName: string) {
        this.tracking.triggerEvent('pageView', { 'page.name': eventName });
    }
    goToComplaintForm() {
        this.navigation.goTo(this.messages.ComplaintFormUrl);
    }
    closeVideo() {
        if (this.contactimagevideo) {
            const element: HTMLElement = this.contactimagevideo.nativeElement as HTMLElement;
            /* Check if iframe exists */
            if (element.getElementsByClassName('embed-responsive-item') && element.getElementsByClassName('embed-responsive-item').length > 0) {
                this.showPlayer = false;
                this.ref.detectChanges();
            }
        }
    }

    get testingLinks(): { key: string; url: string }[] {
        return Object.entries(this.commonClientConfig.testingUrls || {}).map(([key, url]) => ({ key, url }));
    }
}
